import { Box, Container, Grid, GridItem, Heading, Link, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

export default function TerminosCondicionesPortal() {
    return (
        <Container maxWidth="100vw" pt={24} px={{ base: 4, lg: 20 }}>
            <Header />
            <Head>
                <title>Terminos y Condiciones de Contratación del Portal | Grupo Guía</title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3} borderLeftColor="#17669D" borderLeftWidth="3px">
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            href="/terminosycondiciones-guiabroker"
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }}>
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "4xl", base: "2xl" }}
                            textAlign="center"
                            mb="8"
                            color="accent.500"
                            fontWeight="bold"
                            lineHeight={1.2}
                        >
                            TERMINOS Y CONDICIONES DE CONTRATACION DEL PORTAL
                        </Heading>
                    </Box>
                    <Box lineHeight="2" mb="8">
                        <Text textAlign="center" mb={8}>
                            Este documento establece los Términos y Condiciones de contratación para
                            los servicios ofrecidos en{" "}
                            <Link href="https://grupoguia.mx/" mr="2">
                                https://grupoguia.mx/
                            </Link>
                        </Text>
                        <Text>
                            Este contrato contiene los derechos y obligaciones de las partes{" "}
                            <strong>
                                {`(indistintamente, los “Términos y Condiciones Generales GUIA y/o las
                                    "Condiciones")`}
                            </strong>{" "}
                            aplicables al uso de los servicios mismos, ofrecidos por{" "}
                            <strong>GUIA EXCELENCIA INMOBILIARIA S.A. DE C.V.</strong> (“GUIA”),
                            dentro del sitio www.grupoguia.mx. (“Sitio Web”).
                            <br /> <br />
                            Cualquier persona que desee acceder y/o usar el sitio o los Servicios
                            podrá hacerlo sujetándose a las Condiciones junto con todas las demás
                            políticas y principios que rigen <strong>GUIA</strong> y que son
                            incorporados al presente por referencia.
                            <br /> <br />
                            El Usuario debe leer, entender y aceptar todas las condiciones
                            establecidas en los Términos y Condiciones Generales{" "}
                            <strong>GUIA</strong> y el Aviso de Privacidad, establecidos en nuestro
                            Sitio Web, así como en los demás documentos incorporados a los mismos
                            por referencia, previo a su inscripción como Usuario de{" "}
                            <strong>GUIA</strong>.
                            <br /> <br />
                            <strong>GUIA</strong> se reserva el derecho a adicionar o modificar los
                            Términos y Condiciones en cualquier momento. Todas las modificaciones
                            que sean realizadas a los presentes Términos y Condiciones serán
                            notificadas al Usuario a través del Sitio Web y/o correo electrónico y
                            surtirán efectos en el momento en el que sean actualizados.
                            <br /> <br />
                            Cualquier incumplimiento a los Términos y Condiciones faculta a{" "}
                            <strong>GUIA</strong> para dar por terminada cualquier relación con el
                            Usuario, Vendedor y/o Comprador sin necesidad de requerimiento judicial
                            o extrajudicial.
                        </Text>
                    </Box>
                    <Box lineHeight="2" mb="12">
                        <Heading
                            as="h2"
                            mb="6"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            1. OBJETO
                        </Heading>
                        <Text mb={8}>
                            El sitio web de GUIA EXCELENCIA INMOBILIARIA S.A. DE C.V. (en lo
                            sucesivo GUIA) se encuentra disponible para usted en los términos y
                            condiciones que se describen en el sitio web, mismos que puede aceptar
                            sin hacer modificación alguna.
                            <br /> <br />
                            <strong>GUIA</strong> podrá variar, en cualquier momento, los términos y
                            condiciones aquí descritos. Cuando dichas modificaciones, por
                            legislación aplicable, impliquen realizarle notificación y esto sea
                            posible, usted recibirá dicho aviso. Las modificaciones serán efectivas
                            desde el momento de su publicación. El acceso y uso continuado del Sitio
                            Web o los Servicios constituirá la aceptación de las Condiciones
                            modificadas.
                            <br /> <br />
                            El contenido de este sitio web está pensado en usted, para que conozca y
                            se beneficie de los servicios de <strong>GUIA</strong>. No se encuentra
                            permitido el uso de este sitio web para fines distintos de los
                            ofrecidos, por lo que deberá abstenerse de reproducir de manera total o
                            parcial, por cualquier medio, lo que aquí se presenta.
                            <br /> <br />
                            Si usted no se encuentra de acuerdo en estos términos y condiciones, en
                            forma completa y absoluta, deberá usted evitar el acceso, uso y en
                            general observar el sitio web. Al acceder, usar, observar y en general
                            tener contacto con este sitio se entenderá que usted consiente y acepta
                            de manera absoluta lo aquí estipulado.
                            <br /> <br />
                            Es importante que usted conozca que <strong>GUIA</strong> no guardará
                            una copia individualizada del presente convenio celebrado con usted,
                            salvo que usted lo solicite por escrito acudiendo directamente a la
                            dirección Av. Pablo Neruda #2813, Col. Providencia 4ta sección, C.P.
                            44639, Guadalajara, Jalisco.
                            <br /> <br />
                            Por el hecho de utilizar el Sitio Web y/o los Servicios, Usted acepta
                            cumplir los presentes Términos y Condiciones Generales quedando
                            legalmente obligado por ellos, se convierta o no en un usuario
                            registrado de los Servicios. Estas Condiciones rigen su acceso y uso del
                            Sitio Web y los Servicios, y de todos los Contenidos Colectivos, y
                            constituyen un acuerdo legal vinculante entre Usted y{" "}
                            <strong>GUIA</strong>. De igual forma, le solicitamos lea con atención
                            nuestro Aviso de Privacidad
                            <br /> <br />
                            <strong>GUIA</strong> no tiene relación con cualquier vinculación a
                            sitios web de terceros con los que no tenga una relación jurídica en
                            términos de la legislación aplicable para cumplir con los servicios
                            ofrecidos a usted y deslinda los presentes términos y condiciones a
                            cualquier contenido en el sitio de dichos terceros.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            2. ACCESO
                        </Heading>
                        <Text mb={8}>
                            Para tener acceso a los servicios del sitio web, el usuario podrá ser
                            requerido para crear un nombre de usuario y una contraseña. El usuario
                            será el único y exclusivo responsable por la confidencialidad de su
                            identidad digital. En caso de pérdida de usuario y/o contraseña el
                            usuario podrá recuperar su información en el botón de “Recuperar
                            Contraseña”, en caso de robo o vulneración de su nombre de usuario y/o
                            contraseña deberá comunicarlo a <strong>GUIA</strong>, a la brevedad, en
                            la sección de “Soporte Técnico” ubicado en el footer del Home del sitio
                            https://www.grupoguia.mx/ con independencia de las medidas de seguridad
                            que pudiera corresponderle.
                            <br />
                            <br />
                            En caso de que no le sea posible ingresar por su cuenta, puede ponerse
                            en contacto con <strong>GUIA SUPPORT</strong>, en donde le brindaremos
                            la asesoría necesaria para que la realice por sí, o a través de alguno
                            de nuestros miembros del equipo de soporte.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            3. OFERTAS DE EMPLEO
                        </Heading>
                        <Text mb={8}>
                            <strong>GUIA</strong> no oferta empleo a través de este sitio web por lo
                            que se deslinda de cualquier responsabilidad por el uso indebido de un
                            tercero. Si usted desea colaborar con nosotros, se le recomienda llamar
                            a nuestros números oficiales de teléfono, que se encuentran en el
                            contenido del sitio web, para efecto de solicitar información respecto a
                            las vacantes y formas de enviar su información.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            4. PRODUCTOS Y SERVICIOS
                        </Heading>
                        <Text mb={8}>
                            La información que <strong>GUIA</strong> proporciona al usuario sobre
                            productos o servicios en el sitio web son con carácter informativo y
                            orientativo.
                            <br />
                            <br />
                            La información que <strong>GUIA</strong> proporciona al usuario sobre
                            los productos ofertados por <strong>GUIA</strong> son con carácter
                            informativo y orientativo. Si tiene el usuario cualquier duda específica
                            sobre las dimensiones, cualidades, características y especificaciones de
                            los mismos, podrá dejar sus datos para ser contactado por un asesor de
                            ventas autorizado por <strong>GUIA</strong> EXCELENCIA INMOBILIARIA S.A.
                            DE C.V. o en su defecto llamar al número de contacto que aparece en la
                            publicación de la propiedad en específico.
                            <br />
                            <br />
                            Los presentes términos y condiciones son aplicables a las relaciones que
                            se deriven del actuar de los promotores autorizados, con los
                            Propietarios y posibles Inquilinos, a través del servicio que presta{" "}
                            <strong>GUIA</strong>.  
                            <strong>GUIA</strong> se reserva el derecho a cancelar, suspender o
                            anular cualquier compra, oferta, deposito o pedido por el usuario en el
                            sitio web cuando no se cumplan los requisitos o las condiciones normales
                            y necesarias. Se cancelará de manera automática cualquier transacción
                            cuando se detecte o se notifique se realizó con dolo manera indebida por
                            parte del usuario o fuera de los términos y condiciones.
                            <br />
                            <br />
                            El usuario ofertará, comprará o apartará pagando los precios, impuestos
                            y gastos determinados en el producto o servicio de su interés, con los
                            contactos y procedimientos establecidos a su disposición en el sitio
                            web.
                            <br />
                            <br />
                            Al momento de cualquier transacción el usuario recibirá un comprobante
                            que tiene únicamente carácter informativo y no implica aceptación por
                            parte de <strong>GUIA</strong>. El usuario podrá confirmar, por parte de{" "}
                            <strong>GUIA</strong>, que su depósito en garantía fue aceptado a través
                            de la sección “Client Dashboard” y será hasta ese momento que se podrá
                            continuar con el proceso de compraventa entre vendedor y comprador. El
                            plazo máximo que la propiedad podrá permanecer bloqueada para la firma
                            del contrato de compraventa será de 15 días naturales para producto de
                            desarrollo y 10 días naturales para producto de corretaje.{" "}
                            <strong>GUIA</strong> podrá modificar los días que podrá permanecer
                            apartada una propiedad en cualquier momento.
                            <br />
                            <br />
                            Los pagos realizados por el usuario a través de depósitos, tarjeta de
                            débito o crédito se harán a través de plataformas externas,
                            pertenecientes a un tercero cuya operación es ajena a{" "}
                            <strong>GUIA</strong>. Usted, al utilizar dicha plataforma, quedará
                            sujeto a los términos y condiciones del mismo.
                            <br />
                            <br />
                            <strong>GUIA</strong> ofrece los productos y/o servicios bajo un nivel
                            de competencia y uso razonable desde un punto de vista comercial.{" "}
                            <strong>GUIA</strong> no ofrece garantía alguna sobre su uso por lo que
                            usted conoce y acepta expresamente que el uso de este sitio web es bajo
                            su propio riesgo. <strong>GUIA</strong> no se hace errores en el llenado
                            o contenido introducido por usted mismo.
                            <br />
                            <br />
                            En caso de que la aplicación de pagos o cualquier persona informe uso
                            indebido sobre un usuario respecto a datos financieros o personales,
                            otorga el derecho a <strong>GUIA</strong> a realizar las acciones que
                            resulten aplicables de conformidad con la legislación. Lo anterior con
                            independencia de las acciones que <strong>GUIA</strong> considere
                            necesario tales como la cancelación o suspensión del usuario en el sitio
                            web, sin requerir de autorización previa.
                            <br />
                            <br />
                            <strong>GUIA</strong> se reserva el derecho a solicitar al usuario
                            información información adicional antes, durante y después del pedido,
                            cuando así sea requerido para el correcto cumplimiento de las
                            obligaciones adquiridas.
                            <br />
                            <br />
                            Si por cualquier motivo, el usuario encuentra un producto o servicio que
                            se exprese en precio $0.00 deberá entrar en contacto con el centro de
                            atención a cliente de <strong>GUIA</strong>, ya que en ninguna
                            circunstancia se entenderá que un producto o servicio del sitio web no
                            tienen costo, son gratis o regalados, salvo cuando así de manera clara y
                            expresa se le indique al usuario.
                            <br />
                            <br />
                            Todos los productos o servicios se encuentran sujetos a disponibilidad.
                            Si usted realiza un movimiento para generar una oferta, deberá usted
                            saber que no puede considerarlo hecho hasta en tanto no se le confirme
                            de manera clara y precisa por parte de <strong>GUIA</strong>. Si su
                            oferta no pudiere llevarse a cabo, se le notificará y cuando sea
                            posible, se le informará como subsanar los motivos para continuar con su
                            proceso.
                            <br />
                            <br />
                            El usuario asume la responsabilidad de todos los gastos relacionados con
                            costos, tasas o impuestos que se deriven del uso de este sitio web.
                            <br />
                            <br />
                            <strong>GUIA</strong> ofrece una plataforma digital que funciona como
                            intermediario intermediario entre comprador y vendedor de bienes raíces.{" "}
                            <strong>GUIA</strong> no tiene responsabilidad sobre las obligaciones
                            legales generadas entre ambos adquiridas por naturaleza de la figura
                            jurídica de compraventa, o cualquier otra aplicable.
                            <br />
                            <br />
                            Usted recibirá por parte de <strong>GUIA</strong> los servicios
                            relacionados con la promoción y comercialización del inmueble que nos
                            encomiende, limitando su responsabilidad a la presentación de personas
                            interesadas. La evaluación y formalización de la relación jurídica
                            quedará siempre a salvo para que usted en forma directa realice esta
                            acción o bien la haga con asesoría o a través de un profesional
                            especializado de su confianza. <strong>GUIA</strong> en este sentido, no
                            tiene responsabilidad sobre las negociaciones que haga usted en forma
                            directa con el tercero interesado, quedando solamente con derecho al
                            cobro de la comisión  pactada con usted por los servicios en materia de
                            intermediación inmobiliaria.
                            <br />
                            <br />
                            Se le sugiere ampliamente contacte asesores de su plena confianza, con
                            especialidad en la materia legal y de contabilidad, previo a adquirir
                            derechos y obligaciones en forma directa con el interesado en su
                            propiedad.
                            <br />
                            <br />
                            En <strong>GUIA</strong> respetamos el derecho a la transparencia en las
                            propiedades que comercializamos, por lo que usted es responsable de
                            proporcionarnos información veraz y oportuna que permita conocer la
                            situación actual de su propiedad. En caso de contar con gravamen, usted 
                            está enterado debe transmitir libre de gravamen a la escrituración del
                            inmueble, por lo que el tiempo y los gastos que esto implique serán
                            absorbidos por usted en forma directa al cien por ciento. Si usted desea
                            que no sea de esta manera, deberá usted  asesorarse con el profesional
                            de su confianza y pactar con su  comprador lo que a sus intereses mejor
                            convengan. GUIA no puede dar opiniones vinculantes entre las partes,
                            manteniendo una postura imparcial y  ajena a la relación jurídica que
                            surge entre comprador y vendedor.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            5. DERECHOS DE AUTOR
                        </Heading>
                        <Text mb={8}>
                            Algunos derechos de este contenido web son reservados. Se prohíbe la
                            reproducción parcial o total por cualquier medio. Todos los derechos de
                            autor se encuentran protegidos de conformidad con el Convenio de Berna a
                            nivel internacional y la Ley Federal del Derecho de Autor y su
                            reglamento en territorio mexicano.
                            <br />
                            <br />
                            Los derechos de autor son derechos que protegen obras originales y
                            derivadas. Existen distintas obras que se protegen y se pueden consultar
                            en la Ley Federal del Derecho de Autor, entre ellas incluyen los
                            dibujos, diseños, fotografías, videos, sonidos, música.
                            <br />
                            <br />
                            Para que usted se considere autor, es necesario que usted personalmente
                            hubiere realizado la obra o bien, la hubiere encargado a un tercero bajo
                            estipulaciones.
                            <br />
                            <br />
                            Usted al ofrecer un producto o servicio dentro de este sitio web, es
                            responsable frente a terceros del contenido que proporciona de manera
                            directa como diseños, planos arquitectónicos, fotografías,
                            audiovisuales, sonidos y en general material de derecho de autor que sea
                            original y le pertenezca, o bien, pueda comprobar el derecho a la
                            explotación de los mismos. Queda estrictamente prohibido hacer uso de
                            material cuya autoría pertenezca a otra persona sin el consentimiento en
                            términos de la legislación autoral.
                            <br />
                            <br />
                            En caso de que <strong>GUIA</strong> reciba, por cualquier forma, la
                            notificación de un tercero informando sobre el uso no autorizado de
                            derechos de autor, otorgará el derecho a detener el uso de dicho
                            material en el sitio web hasta en tanto usted no compruebe tener la
                            libre explotación. En caso de que se compruebe usted ha hecho uso
                            indebido de derechos de autor de un tercero, dejará al libre albedrío de{" "}
                            <strong>GUIA</strong> la cancelación de su usuario, dar de baja su
                            aviso, o bien, solicitarle el cambio de material.
                            <br />
                            <br />
                            <strong>GUIA</strong> se deslinda de cualquier responsabilidad legal
                            relacionada con el uso de derechos de autor de obras proporcionadas por
                            un usuario. Si usted considera sus derechos de autor han sido vulnerados
                            deberá dar aviso por escrito a <strong>GUIA</strong>, directamente en su
                            domicilio o a través de{" "}
                            <Link href="mailto:contactojuridico@grupoguia.mx">
                                contactojuridico@grupoguia.mx
                            </Link>{" "}
                            . En su documento será necesario que proporcione su nombre completo e
                            indique a detalle cualquier información que resulte indispensable para
                            atender su solicitud, así como un correo electrónico y teléfono de
                            contacto. A esta solicitud deberá acompañar su identificación oficial y
                            cualquier documentación que considere necesaria para comprobar su dicho.
                            <br />
                            <br />
                            <strong>GUIA</strong> no cuenta con facultades para otorgar una opinión
                            legal o emitir una resolución relacionada con la presunta vulnerabilidad
                            de derechos de autor, por lo que se limitará a notificar al usuario
                            sobre la reclamación de la obra. No será responsabilidad de{" "}
                            <strong>GUIA</strong> realizar ningún movimiento adicional con el
                            usuario hasta en tanto no exista una prueba u orden de autoridad
                            competente que demuestre la violación de derechos de un tercero.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            6. PROPIEDAD INDUSTRIAL
                        </Heading>
                        <Text mb={8}>
                            Las marcas y/o avisos comerciales utilizados en el sitio web por parte
                            de <strong>GUIA</strong> son para uso exclusivo de su titular o
                            licenciatario autorizado. Queda prohibido el uso parcial o total, a
                            través de cualquier medio, sin autorización expresa por escrito de su
                            titular. Las marcas, avisos comerciales y cualquier figura de propiedad
                            industrial se encuentran protegidos por los distintos tratados
                            internacionales, así como por la Ley Federal de Protección a la
                            Propiedad Industrial y su reglamento en territorio mexicano.
                            <br />
                            <br />
                            Si usted considera que cualquier contenido publicado en el sitio web
                            viola o vulnera cualquiera de sus derechos de propiedad industrial,
                            podrá enviar su comentario directamente a <strong>GUIA</strong> a través
                            de{" "}
                            <Link href="mailto:contactojuridico@grupoguia.mx">
                                contactojuridico@grupoguia.mx
                            </Link>{" "}
                            .
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            7. USUARIOS AUTORIZADOS
                        </Heading>
                        <Text mb={8}>
                            Usted, al crear una cuenta de usuario, conoce que la misma es personal,
                            única e intransferible. En caso de que <strong>GUIA</strong> identifique
                            dos o más cuentas de usuario con datos idénticos, coincidentes o
                            relacionados, podrá cancelarlos, suspenderlos o inhabilitarlos, a
                            criterio exclusivo de <strong>GUIA</strong>.
                            <br />
                            <br />
                            <strong>GUIA</strong> se reserva el derecho a rechazar una cuenta de
                            usuario cuando no cumpla con los requisitos establecidos en estos
                            términos y condiciones. <strong>GUIA</strong> no se encuentra obligado a
                            emitir informe alguno con los motivos o razones que dieron origen a la
                            decisión, así como tampoco dará derecho a indemnización al usuario.
                            <br />
                            <br />
                            Para el uso de este sitio, usted debe tener por lo menos 18 años
                            cumplidos. Usted al comprar o apartar en este sitio acepta que ha leído
                            y entendido esta información, y que se encuentra de acuerdo. En caso de
                            que un menor de edad desee comprar a través de este sitio web, podrá
                            hacerlo a través de sus padres o representantes, de conformidad con la
                            legislación aplicable.
                            <br />
                            Los padres, tutores o cualquier persona que actúe en representación
                            legal de una persona física o moral, será responsable directo de sus
                            actos según lo dispuestos en los presentes términos y condiciones, con
                            independencia de cualquier norma.
                            <br />
                            <br />
                            <strong>GUIA</strong> se reserva el derecho de restringir ciertas áreas
                            de información de este sitio a nuestros usuarios aprobados y
                            registrados.
                            <br />
                            <br />
                            En el evento de que cualquier área de este sitio le solicite registrarse
                            con nosotros de manera previa para garantizar el acceso a un espacio
                            determinado, usted está de acuerdo que nos proveerá con información
                            verídica y fidedigna, incluyendo sin límite un nombre de usuario y
                            contraseña, así como su nombre, dirección, teléfono y una dirección de
                            correo electrónica válida. Usted acuerda proporcionarnos información
                            verídica y actualizar su cuenta en la forma necesaria.{" "}
                            <strong>GUIA</strong> utilizará su información de conformidad con el
                            aviso de privacidad que puede usted consultar en{" "}
                            <Link href="https://www.grupoguia.mx/aviso-de-privacidad">
                                https://www.grupoguia.mx/aviso-de-privacidad
                            </Link>
                            .
                            <br />
                            <br />
                            Si usted tiene la sospecha o confirma que su cuenta ha sido utilizada
                            por un tercero, deberá dar aviso de inmediato a <strong>GUIA</strong> a
                            efecto de dar de baja su usuario de manera inmediata.
                            <br />
                            El usuario se obliga a indemnizar y sacar a salvo y en paz a{" "}
                            <strong>GUIA</strong>, sus subsidiarias, controladoras, accionistas,
                            directivos, empleados, funcionarios, consejeros, agente y cualquier
                            persona que pudiere estar relacionada de cualquier acción, reclamación,
                            procedimiento, demanda, responsabilidad, daños, perjuicios, gastos,
                            costas que se deriven o se encuentren relacionadas con la violación por
                            parte del usuario a los presentes términos y condiciones, así como a
                            cualquier legislación vigente.
                            <br />
                            <br />
                            <strong>GUIA</strong> se reserva el derecho a asumir de manera directa
                            las acciones relacionadas con la defensa y control de cualquier asunto
                            que pudiera implicar un pago asociado con el incumplimiento de un
                            usuario. El usuario cooperará en todo momento con <strong>GUIA</strong>{" "}
                            proporcionando todo aquello solicitado para la correcta defensa.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            8. USO DE ESTE SITIO
                        </Heading>
                        <Text mb={8}>
                            <strong>GUIA</strong> le permite a usted de manera no limitada, no
                            exclusiva y no transferible, el acceso y licencia de uso de este sitio
                            de conformidad con los términos y condiciones que se muestran en este
                            acuerdo. <strong>GUIA</strong> se reserva cualquier derecho no expresado
                            y que se encuentre protegido por legislación aplicable. Cualquier uso de
                            este sitio no específicamente permitido por estos términos se encuentra
                            estrictamente prohibido.
                            <br />
                            <br />
                            Usted acuerda que no puede: (i) utilizar este sitio para reproducir,
                            transmitir, almacenar o distribuir material legalmente protegido por
                            cualquier medio, vía o método sin la autorización por escrito de{" "}
                            <strong>GUIA</strong> o su titular (ii)copiar, editar, cambiar,
                            preparar, almacenar cualquier obra derivada o cualquier forma de
                            alteración del contenido que se provee en este sitio; o (iii) utilizar
                            nuestro sitio en cualquier forma que viole los términos de este acuerdo.
                            <br />
                            <br />
                            <strong>GUIA</strong> le concede al usuario una licencia de uso no
                            transferible y revocable para el uso del sitio web, en virtud de los
                            presentes términos y condiciones, con el propósito de comprar o vender
                            inmuebles comercializados en la misma página.
                            <br />
                            <br />
                            Cualquier uso contrario a los términos y condiciones realizado por el
                            usuario dará lugar a la revocación inmediata de la licencia otorgada en
                            este apartado, sin previo aviso. Lo anterior con independencia de las
                            infracciones o acciones a que como consecuencia se diera a lugar. El
                            usuario es el único responsable del cuidado de sus contraseñas y otros
                            identificadores.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            9. OTRAS RESTRICCIONES
                        </Heading>
                        <Text mb={10}>
                            Usted acuerda que no: (a) Utilizará este sitio para enviarnos
                            información personal distinta a la que sea solicitada por{" "}
                            <strong>GUIA</strong>. (b) Se abstendrá de utilizar un lenguaje que
                            provoque agresión, racismo, terrorismo, denigre en cualquier forma o
                            violente los derechos humanos de cualquier persona, en cuyo caso{" "}
                            <strong>GUIA</strong> dará de baja su usuario de manera automática y no
                            le dará respuesta, con independencia a las acciones legales a que se
                            pueda hacer acreedor. (c) enviar por este medio cadenas, información
                            comercial, ofertas de negocios, portafolio de servicios profesionales,
                            información sobre seguros o negocios piramidales o buscará personas para
                            actividades personales o comerciales ajenas a <strong>GUIA</strong>, o
                            (d) intentará obtener acceso denegado a otro sistema o computadora a
                            través de este sitio. Usted está de acuerdo en que no utilizará este
                            sitio de cualquier forma que pueda causar daño, inhabilite o afecte en
                            forma alguna el uso de un tercero a este sitio.
                            <br />
                            <br />
                            El acceso al contenido del sitio web puede no ser legal o cumplir con la
                            totalidad de requisitos legales para ciertas personas en determinados
                            países. <strong>GUIA</strong> no presume la legalidad, sino que el
                            usuario es responsable bajo su propio riesgo del uso de este sitio web
                            fuera del territorio de los Estados Unidos Mexicanos.
                            <br />
                            <br />
                            Queda estrictamente prohibido a los usuarios la violación o el intento
                            de violación a la seguridad de este sitio web y de los sitios web
                            afiliados de <strong>GUIA</strong>. Cualquier violación al sistema
                            informático o la seguridad de la red y/o los usuarios le pueden generar
                            responsabilidad de carácter civil, administrativo o penal, y en general
                            a cualquier legislación aplicable.
                            <br />
                            <br />
                            <strong>GUIA</strong> se deslinda de cualquier responsabilidad que
                            pudiera provocar las interrupciones o suspensiones del acceso a internet
                            por cualquier falla en el sistema de telecomunicaciones. De la misma
                            forma, usted conoce que <strong>GUIA</strong> no es responsable ante el
                            daño, pérdida reparable o irreparable, perjuicio y en general cualquier
                            afectación que el usuario pueda tener relacionados sistema, en el
                            servidor o internet. <strong>GUIA</strong> no es ni será responsable de
                            cualquier virus o similar que pudiera ser transferido al equipo del
                            usuario por motivo del uso, acceso, descarga, transferencia de cargas y
                            en general por la interacción con el sitio web.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            10. ENVIOS DE CUALQUIER INFORMACIÓN
                        </Heading>
                        <Text mb={10}>
                            Si usted envía a <strong>GUIA</strong> un post en este sitio,
                            testimonio, duda, comentario, sugerencia o cualquier trabajo autoral
                            incluyendo de manera enunciativa más no limitativa, información sobre
                            cualquiera de nuestros productos o servicios, tome en cuenta que dicho
                            envío no será considerado información confidencial o secreto industrial
                            y por lo tanto no recibirá dicho tratamiento. Por favor no envíe
                            cualquier comentario o información que usted considera contiene
                            información protegida por alguna legislación en favor de un tercero o
                            que usted desee mantener confidencial por este medio, cuando no sea
                            específicamente solicitada por <strong>GUIA</strong>. Ninguna
                            información o contenido que sea enviado por usted será considerado o
                            tratado como confidencial, excepto en los casos en que la legislación
                            así lo requiera a <strong>GUIA</strong>.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            11. TÉRMINOS
                        </Heading>
                        <Text mb={10}>
                            Los términos aquí plasmados permanecerán efectivos hasta en tanto usted
                            termine su relación con nosotros o nosotros con usted.
                            <br />
                            <br />
                            Estos términos y condiciones son de vigencia ilimitada, entrando en
                            vigor al momento de su publicación en este sitio web y sustituyen
                            cualquier otro acuerdo o contrato celebrado con anterioridad, en todo
                            aquello que no contradiga a la legislación.
                            <br />
                            <br />
                            <strong>GUIA</strong> se reserva el derecho a cancelar en cualquier
                            momento el sitio web y/o terminar con los términos y condiciones
                            presentes.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            12. MODIFICACIONES AL SITIO WEB
                        </Heading>
                        <Text mb={12}>
                            <strong>GUIA</strong> tiene el derecho a modificar en cualquier momento,
                            sin necesidad de aviso al usuario, realizar correcciones o adiciones al
                            contenido, formato, presentación y en general a cualquier elemento del
                            sitio web, sin que esto otorgue derecho a ningún tipo de reclamación o
                            indemnización en favor del usuario.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            13. INFORMACION DE RESPALDO.
                        </Heading>
                        <Text mb={8}>
                            Los Miembros deberán proporcionar información precisa, pese a que{" "}
                            <strong>GUIA</strong> puede pedirle directamente o, a través de
                            terceros, con fines de transparencia o prevención o detección de
                            fraudes, que proporcione alguna forma de identificación oficial, su
                            fecha de nacimiento u otros datos y documentos, o llevar a
                            comprobaciones y otros procedimientos adicionales destinados ayudar a
                            verificar o comprobar las identidades o antecedentes de los Miembros y/o
                            contrastar los datos de los Miembros con bases de datos de terceros u
                            otras fuentes de información.
                            <br />
                            <br />
                            {`Toda referencia incluida en el Sitio Web o los Servicios a un Miembro
                                "verificado" o "conectado" (u otro término similar) únicamente indica
                                que ese Miembro ha completado el proceso de verificación o
                                identificación correspondiente. Una descripción de ese tipo no
                                constituye ningún tipo de respaldo, certificación o garantía por parte
                                de <strong>GUIA</strong> acerca de ningún Miembro, o si es fiable,
                                fehaciente o idóneo. En lugar de ello, dicha descripción tiene por
                                objeto ser una información útil que podrá valorar cuando adopte sus
                                propias decisiones acerca de la identidad y la idoneidad de otras
                                personas con quienes entre en contacto o interactúe a través del Sitio
                                Web y los Servicios. En consecuencia, le recomendamos que empleé siempre
                                su sentido común y toda su atención a la hora de decidir respecto a
                                cualquier toma de decisión sobre su Inmueble, así como aceptar o
                                pre-autorizar el Apartado de un o interactuar de cualquier otro modo con
                                otros Miembros. Salvo en los casos previstos en estas Condiciones y en
                                especial al apartado de Seguridad de <strong>GUIA</strong> (y el
                                Respaldo de <strong>GUIA</strong> que es un acuerdo entre{" "}
                                <strong>GUIA</strong> y los usuarios. Asimismo, no nos hacemos
                                responsables de ningún daño o lesión que resulte de sus interacciones
                                con los otros Miembros.`}
                            <br />
                            <br />
                            Por el hecho de utilizar el Sitio Web o los Servicios, Usted acepta que
                            cualquier recurso legal o responsabilidad civil que pretenda obtener a
                            causa de acciones u omisiones de otros Miembros o terceros se limitarán
                            a una reclamación contra los Miembros o terceros concretos causantes de
                            los daños. Usted acepta no intentar atribuir ninguna responsabilidad a{" "}
                            <strong>GUIA</strong>, u obtener ningún recurso legal en relación con{" "}
                            <strong>GUIA</strong> con respecto a dichas acciones u omisiones. En
                            consecuencia, le recomendamos que se ponga en contacto directamente con
                            la contraparte a través del Sitio Web y los Servicios sobre cualquier
                            Apartado o Anuncios realizados por Usted.
                            <br />
                            <br />
                            Usted acepta y está de acuerdo en que Usted, y no <strong>
                                GUIA
                            </strong>{" "}
                            será responsable de cumplir las obligaciones de las operaciones de
                            compraventa que se deriven del uso de la plataforma, siendo{" "}
                            <strong>GUIA</strong> únicamente un intermediario entre las partes y en
                            el entendido que <strong>GUIA</strong> no es parte de dichos contratos y
                            que, a excepción de las obligaciones de <strong>GUIA</strong> derivadas
                            de los Términos y Condiciones <strong>GUIA</strong> así como las
                            incluidas en la presente, y que se encuentran para su consulta en el
                            Sitio Web. <strong>GUIA</strong> rechaza toda responsabilidad derivada
                            de o relacionada con dichos contratos.
                            <br />
                            Usted, como Propietario, acepta pagar las Comisiones Totales conforme a
                            los Términos y Condiciones de Servicios de Pago a <strong>
                                GUIA
                            </strong>{" "}
                            y a los Términos y Condiciones de Comisiones, ambos del Sitio Web.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            14. PREVENCION DE LAVADO DE DINERO.
                        </Heading>
                        <Text mb={8}>
                            El Usuario reconoce, acepta y garantiza, que ni él ni sus accionistas,
                            socios y/o representantes:
                            <br />
                            Se encuentran vinculados, nacional o internacionalmente, a ningún tipo
                            de investigaciones por conductas relacionadas con narcotráfico,
                            terrorismo, financiamiento al terrorismo, secuestro, lavado de activos
                            y/o cualquier otra actividad vinculada a la administración de recursos
                            relacionados con las conductas descritas y/o manejar, de forma directa o
                            indirecta recursos con operaciones de procedencia ilícita.
                            <br />
                            <br />
                            Han sido condenados por parte de las autoridades jurisdiccionales y/o
                            administrativas, nacional o internacionalmente, en cualquier tipo de
                            proceso relacionado con la ejecución de las anteriores conductas o de
                            actividades conexas a tales conductas.
                            <br />
                            <br />
                            Están o han estado incluidos en listas o bases de datos para el control
                            de lavado de activos y financiación del terrorismo administradas por
                            cualquier autoridad nacional o extranjera.
                            <br />
                            <br />
                            La ocurrencia de cualquiera de las situaciones descritas anteriormente,
                            obligan al Usuario a informar inmediatamente a <strong>
                                GUIA
                            </strong>{" "}
                            sobre tal situación y será el Usuario el único y exclusivo responsable
                            por cualquier consecuencia jurídica derivada. Por lo tanto y para todos
                            los efectos legales, el usuario reconoce que el <strong>GUIA</strong>{" "}
                            actúa como un tercero de buena fe.
                            <br />
                            <br />
                            En términos a lo dispuesto por el artículo 18 de la Ley Federal para la
                            Prevención e Identificación de Operaciones con Recursos de Procedencia
                            Ilícita, usted manifiesta bajo protesta de decir verdad que los recursos
                            utilizados para cualquier tipo de operación gestionada dentro del sitio
                            tienen procedencia licita y que son derivados de la actividad que usted
                            manifiesto en el apartado de REGISTRO, lo anterior para todos los
                            efectos legales a que hubiere lugar, autorizando a <strong>GUIA</strong>
                            ” o a su representante legal para que presenten el aviso a que se
                            refiere el artículo 23 y 24 de la Ley de referencia.
                            <br />
                            <br />
                            Por lo anterior, cualquier incumplimiento a tales disposiciones por
                            parte del Usuario facultará a <strong>GUIA</strong> a suspender, de
                            forma inmediata y sin responsabilidad, la prestación de todo tipo de
                            Servicios en favor del Usuario.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            15. PROPIETARIOS
                        </Heading>
                        <Text mb={8}>
                            Al usted visitar este sitio web para la promoción de un inmueble, acepta
                            que tiene la libre disposición del mismo y no se encuentra afectando el
                            derecho de un tercero. Usted acepta no puede promover en este sitio
                            propiedades que no puedan ser sujetas a escrituración de manera
                            inmediata. Es obligación de usted asesorarse legalmente para conocer las
                            disposiciones aplicables que le permitan firmar y ofrecer una propiedad
                            al público en general. Se prohíbe la publicación de propiedades que se
                            encuentren en proceso de litigio, intestadas, que no cuenten con título
                            de propiedad o escritura pública, embargadas, arrendadas, vinculadas con
                            alguna investigación criminal, otorgadas en usufructo y en general con
                            cualquier tipo de restricción de dominio.
                            <br />
                            <br />
                            Es su obligación proporcionar todos los documentos para disposición del
                            posible comprador, así como responder por las garantías en forma
                            directa, entregar el inmueble con la debida acta de entrega y en general
                            cualquiera que el comprador requiera para su debida toma de decisión.
                            <br />
                            <br />
                            Toda la información, documentos, fotografías que usted proporcione en
                            este sitio web debe ser verídica, de no hacerlo usted responderá en
                            forma directa a quien resulte afectado con la documentación falsa.
                            <br />
                            <br />
                            En este sitio web no se permite la publicidad engañosa, por lo que debe
                            mostrar fotografías y videos actualizados, así como informar de manera
                            transparente las condiciones de su propiedad.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            16. ASPECTOS GENERALES
                        </Heading>
                        <Text mb={8}>
                            <strong>GUIA</strong> solamente ofrece servicios a través de este sitio
                            y con distribuidores autorizados. Usted puede contactarnos para
                            informarnos de cualquier producto o servicio que se ostente o resulte
                            similar en grado de confusión con cualquiera de nuestras marcas o
                            diseños por persona ajena a <strong>GUIA</strong>. Si sospecha de
                            cualquier infracción que se cometa en contra de nuestros productos y
                            marcas, puede usted enviarnos un comunicado al domicilio que se muestra
                            en este sitio o bien, a nuestros teléfonos, de manera anónima.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            17. JURISDICCION APLICABLE
                        </Heading>
                        <Text mb={8}>
                            Las disposiciones de los presentes Términos y Condiciones Generales{" "}
                            <strong>GUIA</strong>, respecto a los Servicios, y el Sitio Web, se
                            regirán en todos sus puntos por las leyes vigentes en la República
                            Mexicana, en particular respecto de mensajes de datos, contratación
                            electrónica y comercio electrónico, se regirá por lo dispuesto por la
                            legislación federal respectiva.
                            <br />
                            <br />
                            Para la interpretación, cumplimiento y ejecución del presente contrato
                            (Términos y Condiciones Generales <strong>GUIA</strong> respecto al
                            Servicio, en el Sitio Web), las partes se someten expresamente a los
                            Tribunales del Primer Partido Judicial del Estado de Jalisco,
                            renunciando al fuero de sus domicilios presentes o futuros que pudiera
                            corresponderles.
                            <br />
                            <br />
                            Cualquier controversia derivada del Venta celebrado entre los Miembros
                            (Comprador y Vendedor), su existencia, validez, interpretación, alcance
                            o cumplimiento, será sometido y/o resuelto conforme a lo estipulado en
                            dicho contrato de compraventa o promesa de compraventa,{" "}
                            <strong>GUIA</strong> no es parte de ningún acuerdo firmado entre los
                            Compradores y Vendedores.
                            <br />
                            <br />
                            El usuario conoce su obligación de pago de daños y perjuicios en favor
                            de <strong>GUIA</strong>, sus afiliados, proveedores, accionistas,
                            funcionarios, empleados, asesores y en general cualquier persona física
                            o moral que por cualquier acción judicial o extrajudicial derivada del
                            incumplimiento del usuario al presente convenio, así como al aviso de
                            privacidad y en general la relación generada con <strong>GUIA</strong>{" "}
                            derivada de:
                            <br />
                            <Text as="span" mb={8} ml={6} textIndent={-24}>
                                1.- El uso de este sitio web
                            </Text>
                            <Text as="span" mb={8} ml={6} textIndent={-24}>
                                2.- Información contenida o disponible a través del sitio web que
                                impliquen violación a los derechos de privacidad trasgrediendo los
                                derechos al honor, la imagen, la vida privada y la autodeterminación
                                informativa.
                            </Text>
                            <Text as="span" mb={8} ml={6} textIndent={-24}>
                                3.- Amenazas, violencia, terrorismo, difamación o injurias a
                                cualquier persona y en general información prohibida por la materia
                                de derechos humanos, la Constitución Política de los Estados Unidos
                                Mexicanos, los Tratados Internacionales de los que México forma
                                parte y en general legislación aplicable en territorio mexicano.
                            </Text>
                            El no ejercicio de alguna acción por parte de <strong>GUIA</strong> a
                            alguna acción legal, no implica la renuncia de ésta a aquella.
                            <br />
                            <br />
                            Para el supuesto en que cualquier letra, palabra, enunciado, línea o
                            párrafo establecida en los presentes términos y condiciones resultara
                            ilegal, nula, no aplicable o de imposible ejecución no implica la
                            invalidez o cancelación de todas las demás disposiciones de los términos
                            y condiciones, sino que solamente se tendrá por no puesto aquello que se
                            vea afectado prevaleciendo la validez y legitimidad en todo lo demás.
                            <br />
                            <br />
                            Los títulos o encabezados mostrados dentro de los presentes términos y
                            condiciones funcionan únicamente como referencia e identificación, por
                            lo que no deberán ser tomados como parte del texto para efectos de
                            interpretación jurídica.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            18. LIMITACION DE RESPONSABILIDAD
                        </Heading>
                        <Text mb={8}>
                            Usted reconoce y acepta, en el grado máximo permitido por la ley que,
                            asume todos los riesgos derivados de su acceso y uso del sitio web, los
                            servicios y los contenidos colectivos, su anuncio o el apartado de
                            cualquier inmueble en venta a través del sitio web y de los servicios,
                            su participación, así como cualquier contacto que tenga con otros
                            usuarios de <strong>GUIA</strong>, ya sea en persona o por internet.
                            <br />
                            <br />
                            Ni <strong>GUIA</strong> ni ninguna de las otras partes que intervengan
                            en la creación, producción u ofrecimiento del sitio web, los servicios,
                            los contenidos colectivos responderán por daños fortuitos,
                            cuantificables, indirectos, punitivos o emergentes, incluidos la pérdida
                            de beneficios, de datos de fondo de comercio, la interrupción del
                            servicio, desperfectos informáticos o fallos de sistema, o el coste de
                            productos o servicios alternativos, ni por daños personales, lesiones o
                            daños psicológicos que se deriven de estas condiciones o que guarden
                            relación con las mismas; que surjan del uso o imposibilidad de uso del
                            sitio web, los servicios o los contenidos colectivos; que sobrevengan a
                            raíz de cualquier comunicación, interacción o encuentro con otros
                            usuarios del sitio web o los servicios u otras personas con quienes
                            usted se comunique o interactúe como consecuencia del uso que usted haga
                            del sitio web o los servicios, o de su anuncio o el apartado de
                            cualquier inmueble en venta a través del sitio web o los servicios, ya
                            estén fundamentados en principios de garantía, contractuales, de
                            ilícitos civiles (incluida negligencia), de responsabilidad por producto
                            defectuoso o cualquier otro principio jurídico, y haya sido o no
                            informado <strong>GUIA</strong> de la posibilidad de dicho daño, aun
                            cuando se apreciara que un recurso jurídico limitado recogido en el
                            presente ha fallado en su propósito esencial.
                            <br />
                            <br />
                            Si usted decide utilizar el sitio web, los servicios, o los contenidos
                            colectivos lo hace asumiendo todos los riesgos, El Usuario acepta que el
                            acceso a la Plataforma y el acceso a los Servicios los realiza bajo su
                            propio riesgo. Ni GUIA, ni sus accionistas, directores, funcionarios,
                            empleados, afiliados o agentes garantizan que la Plataforma estará libre
                            de interrupciones o errores; tampoco hace ninguna garantía en cuanto a
                            los resultados que se pueden obtener del uso de la misma o en cuanto a
                            la exactitud, confiabilidad, adecuación o contenido de la información
                            que aparece en la Plataforma., ni sus accionistas, directores,
                            funcionarios, empleados, afiliados o agentes garantizan que la
                            Plataforma estará libre de interrupciones o errores; tampoco hace
                            ninguna garantía en cuanto a los resultados que se pueden obtener del
                            uso de la misma o en cuanto a la exactitud, confiabilidad, adecuación o
                            contenido de la información que aparece en la Plataforma.
                            <br />
                            <br />
                            Usted acepta que ha leído este acuerdo, lo entiende y acepta.
                        </Text>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
}
